import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c652a0e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "ModalSelectCompetitor",
  tabindex: "-1",
  "aria-labelledby": `ModalExcellURLList`,
  "aria-hidden": "true",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = {
  class: "modal-content",
  style: {"overflow":"hidden","border-radius":"12px"}
}
const _hoisted_4 = {
  class: "modal-header px-3 py-6",
  id: "headerModal",
  style: {}
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center\" style=\"gap:1rem;\" data-v-c652a0e6><div class=\"d-flex align-items-center justify-content-center ms-4\" style=\"width:3rem;height:3rem;border-radius:8px;background-color:#F9F9F9;\" data-v-c652a0e6><svg width=\"40\" height=\"41\" viewBox=\"0 0 40 41\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-c652a0e6><rect y=\"0.5\" width=\"40\" height=\"40\" rx=\"8\" fill=\"#F9F9F9\" data-v-c652a0e6></rect><path d=\"M26.9756 17.1194C26.8226 18.5644 25.9482 19.9698 24.3558 20.9693C22.0797 22.4469 19.0619 22.7798 16.5606 22.3378C15.6704 23.1735 14.7486 23.6236 13.885 23.8372C14.1359 24.2797 14.4559 24.679 14.8065 25.0312C15.1569 26.6095 13 28.4115 13 28.4115C13.6071 28.7644 16.7415 29.984 19.5606 27.3378C22.0619 27.7798 25.0797 27.4469 27.3558 25.9693C30.8756 23.7599 30.8871 19.5679 27.3558 17.3469C27.2328 17.267 27.1059 17.1912 26.9756 17.1194Z\" fill=\"#203972\" data-v-c652a0e6></path><path opacity=\"0.4\" d=\"M23.5114 12.2433C21.3744 10.8818 18 10.8191 16 11.2048C15.4273 11.3152 14.5214 11.5212 13.6 11.9762C12.744 12.399 11.7759 13.0719 11.2 13.9048C9.6 16.2191 10.4394 18.0944 11.7003 19.3365C12.03 20.7934 10 22.4568 10 22.4568C10.5714 22.7825 13.5214 23.9083 16.1747 21.4657C18.5289 21.8737 21.3691 21.5664 23.5114 20.2025C26.8241 18.163 26.835 14.2935 23.5114 12.2433Z\" fill=\"#203972\" data-v-c652a0e6></path></svg></div><div data-v-c652a0e6><h2 style=\"white-space:nowrap;\" data-v-c652a0e6>Social</h2><span data-v-c652a0e6>Nova mensagem</span></div></div>", 1)
const _hoisted_6 = {
  class: "d-flex align-items-center w-50 justify-content-end px-3",
  style: {"gap":"1rem"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.6641 9.5L17.5503 4.61377C18.1499 4.01416 18.1499 3.04199 17.5503 2.44189L16.4644 1.35596C15.8647 0.756348 14.8926 0.756348 14.2925 1.35596L9.40625 6.24219L4.52002 1.35596C3.92041 0.756348 2.94824 0.756348 2.34814 1.35596L1.26221 2.44189C0.662598 3.0415 0.662598 4.01367 1.26221 4.61377L6.14844 9.5L1.26221 14.3862C0.662598 14.9858 0.662598 15.958 1.26221 16.5581L2.34814 17.644C2.94775 18.2437 3.92041 18.2437 4.52002 17.644L9.40625 12.7578L14.2925 17.644C14.8921 18.2437 15.8647 18.2437 16.4644 17.644L17.5503 16.5581C18.1499 15.9585 18.1499 14.9863 17.5503 14.3862L12.6641 9.5Z",
    fill: "#B5B5C3"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  class: "modal-body selectSended",
  style: {"background-color":"var(--cor_background_2)"}
}
const _hoisted_10 = { class: "card p-4" }
const _hoisted_11 = { class: "d-flex justify-content-between align-items-end section_switch_notification_select" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "1. Para quem enviar", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "2. Configurações", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "3. Conteúdo", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "4. Notificação", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "p-4" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-c652a0e6><rect width=\"40\" height=\"40\" rx=\"8\" fill=\"#F9F9F9\" data-v-c652a0e6></rect><g clip-path=\"url(#clip0_1796_2185)\" data-v-c652a0e6><path d=\"M23.457 16.25C22.8906 12.7617 21.5547 10.3125 20 10.3125C18.4453 10.3125 17.1094 12.7617 16.543 16.25H23.457ZM16.25 20C16.25 20.8672 16.2969 21.6992 16.3789 22.5H23.6172C23.6992 21.6992 23.7461 20.8672 23.7461 20C23.7461 19.1328 23.6992 18.3008 23.6172 17.5H16.3789C16.2969 18.3008 16.25 19.1328 16.25 20ZM28.9336 16.25C27.8164 13.5977 25.5547 11.5469 22.7617 10.7188C23.7148 12.0391 24.3711 14.0273 24.7148 16.25H28.9336ZM17.2344 10.7188C14.4453 11.5469 12.1797 13.5977 11.0664 16.25H15.2852C15.625 14.0273 16.2812 12.0391 17.2344 10.7188ZM29.3516 17.5H24.8711C24.9531 18.3203 25 19.1602 25 20C25 20.8398 24.9531 21.6797 24.8711 22.5H29.3477C29.5625 21.6992 29.6836 20.8672 29.6836 20C29.6836 19.1328 29.5625 18.3008 29.3516 17.5ZM15 20C15 19.1602 15.0469 18.3203 15.1289 17.5H10.6484C10.4375 18.3008 10.3125 19.1328 10.3125 20C10.3125 20.8672 10.4375 21.6992 10.6484 22.5H15.125C15.0469 21.6797 15 20.8398 15 20ZM16.543 23.75C17.1094 27.2383 18.4453 29.6875 20 29.6875C21.5547 29.6875 22.8906 27.2383 23.457 23.75H16.543ZM22.7656 29.2812C25.5547 28.4531 27.8203 26.4023 28.9375 23.75H24.7188C24.375 25.9727 23.7187 27.9609 22.7656 29.2812ZM11.0664 23.75C12.1836 26.4023 14.4453 28.4531 17.2383 29.2812C16.2852 27.9609 15.6289 25.9727 15.2852 23.75H11.0664Z\" fill=\"#203972\" data-v-c652a0e6></path></g><defs data-v-c652a0e6><clipPath id=\"clip0_1796_2185\" data-v-c652a0e6><rect width=\"20\" height=\"20\" fill=\"white\" transform=\"translate(10 10)\" data-v-c652a0e6></rect></clipPath></defs></svg><span style=\"background-color:transparent;cursor:pointer;border:none;width:70%;\" class=\"form-control p-0 hoverInput\" size=\"large\" data-v-c652a0e6> Enviar para todos </span><i class=\"fa fa-arrow-right\" id=\"container_ISearch\" aria-hidden=\"true\" style=\"right:1.5rem;top:0.8rem;margin:0;padding:0;font-size:1.5rem;color:var(--cor_btn_1);\" data-v-c652a0e6></i>", 3)
const _hoisted_25 = [
  _hoisted_22
]
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-c652a0e6><rect width=\"40\" height=\"40\" rx=\"8\" fill=\"#F9F9F9\" data-v-c652a0e6></rect><path opacity=\"0.3\" d=\"M28.2812 28.75H27.5V10.9375C27.5 10.4197 27.0803 10 26.5625 10H13.4375C12.9197 10 12.5 10.4197 12.5 10.9375V28.75H11.7188C11.4599 28.75 11.25 28.9599 11.25 29.2188V30H28.75V29.2188C28.75 28.9599 28.5401 28.75 28.2812 28.75ZM16.25 12.9688C16.25 12.7099 16.4599 12.5 16.7188 12.5H18.2812C18.5401 12.5 18.75 12.7099 18.75 12.9688V14.5312C18.75 14.7901 18.5401 15 18.2812 15H16.7188C16.4599 15 16.25 14.7901 16.25 14.5312V12.9688ZM16.25 16.7188C16.25 16.4599 16.4599 16.25 16.7188 16.25H18.2812C18.5401 16.25 18.75 16.4599 18.75 16.7188V18.2812C18.75 18.5401 18.5401 18.75 18.2812 18.75H16.7188C16.4599 18.75 16.25 18.5401 16.25 18.2812V16.7188ZM18.2812 22.5H16.7188C16.4599 22.5 16.25 22.2901 16.25 22.0312V20.4688C16.25 20.2099 16.4599 20 16.7188 20H18.2812C18.5401 20 18.75 20.2099 18.75 20.4688V22.0312C18.75 22.2901 18.5401 22.5 18.2812 22.5ZM21.25 28.75H18.75V25.4688C18.75 25.2099 18.9599 25 19.2188 25H20.7812C21.0401 25 21.25 25.2099 21.25 25.4688V28.75ZM23.75 22.0312C23.75 22.2901 23.5401 22.5 23.2812 22.5H21.7188C21.4599 22.5 21.25 22.2901 21.25 22.0312V20.4688C21.25 20.2099 21.4599 20 21.7188 20H23.2812C23.5401 20 23.75 20.2099 23.75 20.4688V22.0312ZM23.75 18.2812C23.75 18.5401 23.5401 18.75 23.2812 18.75H21.7188C21.4599 18.75 21.25 18.5401 21.25 18.2812V16.7188C21.25 16.4599 21.4599 16.25 21.7188 16.25H23.2812C23.5401 16.25 23.75 16.4599 23.75 16.7188V18.2812ZM23.75 14.5312C23.75 14.7901 23.5401 15 23.2812 15H21.7188C21.4599 15 21.25 14.7901 21.25 14.5312V12.9688C21.25 12.7099 21.4599 12.5 21.7188 12.5H23.2812C23.5401 12.5 23.75 12.7099 23.75 12.9688V14.5312Z\" fill=\"#203972\" data-v-c652a0e6></path><path d=\"M16.25 12.9688C16.25 12.7099 16.4599 12.5 16.7188 12.5H18.2812C18.5401 12.5 18.75 12.7099 18.75 12.9688V14.5312C18.75 14.7901 18.5401 15 18.2812 15H16.7188C16.4599 15 16.25 14.7901 16.25 14.5312V12.9688ZM16.25 16.7188C16.25 16.4599 16.4599 16.25 16.7188 16.25H18.2812C18.5401 16.25 18.75 16.4599 18.75 16.7188V18.2812C18.75 18.5401 18.5401 18.75 18.2812 18.75H16.7188C16.4599 18.75 16.25 18.5401 16.25 18.2812V16.7188ZM18.2812 22.5H16.7188C16.4599 22.5 16.25 22.2901 16.25 22.0312V20.4688C16.25 20.2099 16.4599 20 16.7188 20H18.2812C18.5401 20 18.75 20.2099 18.75 20.4688V22.0312C18.75 22.2901 18.5401 22.5 18.2812 22.5ZM21.25 28.75H18.75V25.4688C18.75 25.2099 18.9599 25 19.2188 25H20.7812C21.0401 25 21.25 25.2099 21.25 25.4688V28.75ZM23.75 22.0312C23.75 22.2901 23.5401 22.5 23.2812 22.5H21.7188C21.4599 22.5 21.25 22.2901 21.25 22.0312V20.4688C21.25 20.2099 21.4599 20 21.7188 20H23.2812C23.5401 20 23.75 20.2099 23.75 20.4688V22.0312ZM23.75 18.2812C23.75 18.5401 23.5401 18.75 23.2812 18.75H21.7188C21.4599 18.75 21.25 18.5401 21.25 18.2812V16.7188C21.25 16.4599 21.4599 16.25 21.7188 16.25H23.2812C23.5401 16.25 23.75 16.4599 23.75 16.7188V18.2812ZM23.75 14.5312C23.75 14.7901 23.5401 15 23.2812 15H21.7188C21.4599 15 21.25 14.7901 21.25 14.5312V12.9688C21.25 12.7099 21.4599 12.5 21.7188 12.5H23.2812C23.5401 12.5 23.75 12.7099 23.75 12.9688V14.5312Z\" fill=\"#203972\" data-v-c652a0e6></path></svg><span style=\"background-color:transparent;cursor:pointer;border:none;width:70%;\" class=\"form-control p-0 hoverInput\" size=\"large\" data-v-c652a0e6> Enviar para companhias inteiras </span><i class=\"fa fa-arrow-right\" id=\"container_ISearch\" aria-hidden=\"true\" style=\"right:1.5rem;top:0.8rem;margin:0;padding:0;font-size:1.5rem;color:var(--cor_btn_1);\" data-v-c652a0e6></i>", 3)
const _hoisted_29 = [
  _hoisted_26
]
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-c652a0e6><rect width=\"40\" height=\"40\" rx=\"8\" fill=\"#F9F9F9\" data-v-c652a0e6></rect><path opacity=\"0.3\" d=\"M20.0004 24H14.0004V19H12.0004V27C12.0004 27.5531 12.4472 28 13.0004 28H21.0004C21.5535 28 22.0004 27.5531 22.0004 27V19H20.0004V24ZM29.8316 16.4437L27.166 12.4437C26.9785 12.1656 26.666 12 26.3316 12H13.6691C13.3347 12 13.0222 12.1656 12.8379 12.4437L10.1722 16.4437C9.72848 17.1094 10.2035 18 11.0035 18H29.0004C29.7972 18 30.2722 17.1094 29.8316 16.4437ZM26.0004 27.5C26.0004 27.775 26.2254 28 26.5004 28H27.5004C27.7754 28 28.0004 27.775 28.0004 27.5V19H26.0004V27.5Z\" fill=\"#203972\" data-v-c652a0e6></path><path d=\"M29.8311 16.4437L27.1655 12.4437C26.978 12.1656 26.6655 12 26.3311 12H13.6686C13.3342 12 13.0217 12.1656 12.8374 12.4437L10.1717 16.4437C9.72799 17.1094 10.203 18 11.003 18H28.9999C29.7967 18 30.2717 17.1094 29.8311 16.4437Z\" fill=\"#203972\" data-v-c652a0e6></path></svg><span style=\"background-color:transparent;cursor:pointer;border:none;width:70%;\" class=\"form-control p-0 hoverInput\" size=\"large\" data-v-c652a0e6> Enviar para lojas especificas </span><i class=\"fa fa-arrow-right\" id=\"container_ISearch\" aria-hidden=\"true\" style=\"right:1.5rem;top:0.8rem;margin:0;padding:0;font-size:1.5rem;color:var(--cor_btn_1);\" data-v-c652a0e6></i>", 3)
const _hoisted_33 = [
  _hoisted_30
]
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-c652a0e6><rect width=\"40\" height=\"40\" rx=\"8\" fill=\"#F9F9F9\" data-v-c652a0e6></rect><g clip-path=\"url(#clip0_1796_2207)\" data-v-c652a0e6><path opacity=\"0.3\" d=\"M20 21.25C23.1055 21.25 25.625 18.7305 25.625 15.625C25.625 12.5195 23.1055 10 20 10C16.8945 10 14.375 12.5195 14.375 15.625C14.375 18.7305 16.8945 21.25 20 21.25ZM25 22.5H22.8477C21.9805 22.8984 21.0156 23.125 20 23.125C18.9844 23.125 18.0234 22.8984 17.1523 22.5H15C12.2383 22.5 10 24.7383 10 27.5V28.125C10 29.1602 10.8398 30 11.875 30H28.125C29.1602 30 30 29.1602 30 28.125V27.5C30 24.7383 27.7617 22.5 25 22.5Z\" fill=\"#203972\" data-v-c652a0e6></path><path d=\"M25 22.5H22.8477C21.9805 22.8984 21.0156 23.125 20 23.125C18.9844 23.125 18.0234 22.8984 17.1523 22.5H15C12.2383 22.5 10 24.7383 10 27.5V28.125C10 29.1602 10.8398 30 11.875 30H28.125C29.1602 30 30 29.1602 30 28.125V27.5C30 24.7383 27.7617 22.5 25 22.5Z\" fill=\"#203972\" data-v-c652a0e6></path></g><defs data-v-c652a0e6><clipPath id=\"clip0_1796_2207\" data-v-c652a0e6><rect width=\"20\" height=\"20\" fill=\"white\" transform=\"translate(10 10)\" data-v-c652a0e6></rect></clipPath></defs></svg><span style=\"background-color:transparent;cursor:pointer;border:none;width:70%;\" class=\"form-control p-0 hoverInput\" size=\"large\" data-v-c652a0e6> Enviar para vendedores especificos </span><i class=\"fa fa-arrow-right\" id=\"container_ISearch\" aria-hidden=\"true\" style=\"right:1.5rem;top:0.8rem;margin:0;padding:0;font-size:1.5rem;color:var(--cor_btn_1);\" data-v-c652a0e6></i>", 3)
const _hoisted_37 = [
  _hoisted_34
]
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  class: "col-12 p-2 me-0",
  id: "container_inputSearch",
  style: {"position":"relative"}
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-search",
  id: "container_ISearch",
  "aria-hidden": "true",
  style: {"position":"absolute","cursor":"text","right":"1.5rem","top":"1.2rem","margin":"0","padding":"0","font-size":"1.5rem","color":"var(--cor_btn_1)"}
}, null, -1))
const _hoisted_41 = {
  class: "d-flex justify-content-between align-items-center p-2",
  style: {"border-bottom":"1px solid var(--cor_background_2)","font-weight":"500","cursor":"pointer","margin-right":"0.4rem"}
}
const _hoisted_42 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_43 = {
  class: "d-flex flex-column listContainer p-0",
  style: {"overflow-y":"scroll","max-height":"20rem"}
}
const _hoisted_44 = {
  key: 0,
  class: "card d-flex flex-row gap-2 p-2",
  style: {"border":"1px solid var(--cor_background_2)","flex-wrap":"wrap"}
}
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-times",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 2,
  class: "card container mt-4 p-4 d-flex gap-4"
}
const _hoisted_49 = { class: "row" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "select-sender-68c1a29e-c6e2-4feb-b6ec-9fb9debb6432",
  class: "form-label w-100 mb-0"
}, "Remetente", -1))
const _hoisted_51 = {
  key: 0,
  class: "col-6"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "select-company-68c1a29e-c6e2-4feb-b6ec-9fb9debb6432",
  class: "form-label w-100 mb-0",
  style: {"opacity":"0"}
}, "Opção", -1))
const _hoisted_53 = {
  key: 1,
  class: "col-6"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "select-store-68c1a29e-c6e2-4feb-b6ec-9fb9debb6432",
  class: "form-label w-100 mb-0",
  style: {"opacity":"0"}
}, "Opção", -1))
const _hoisted_55 = {
  id: "select-send-date-cb32f05b-8852-4378-abdd-a382a59d7ed2",
  style: {"position":"relative"}
}
const _hoisted_56 = { class: "date-time-picker flex-column flex-md-row" }
const _hoisted_57 = {
  id: "select-input-date",
  class: "w-100"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label w-100 mb-0 p-0" }, "Data", -1))
const _hoisted_59 = {
  id: "select-input-hour",
  class: "w-100"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label w-100 mb-0 p-0" }, "Hora", -1))
const _hoisted_61 = { key: 3 }
const _hoisted_62 = {
  class: "d-flex gap-2 p-2 m-2 flex-wrap align-items-center",
  style: {"border":"1.5px solid var(--cor_background_2)","border-radius":".3rem"}
}
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { key: 2 }
const _hoisted_66 = {
  key: 0,
  class: "d-flex gap-2 p-2 m-2 flex-wrap align-items-center",
  style: {"border":"1.5px solid var(--cor_background_2)","border-radius":".3rem"}
}
const _hoisted_67 = ["onClick"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-times",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = {
  key: 1,
  class: "d-flex gap-2 p-2 m-2 flex-wrap align-items-center",
  style: {"border":"1.5px solid var(--cor_background_2)","border-radius":".3rem"}
}
const _hoisted_71 = {
  class: "px-2",
  style: {"display":"grid","gap":".5rem","grid-template-columns":"auto 60px"}
}
const _hoisted_72 = {
  class: "d-flex align-items-center justify-content-between px-2 py-1",
  style: {"border":"1.5px solid var(--cor_background_2)","border-radius":".3rem"}
}
const _hoisted_73 = { class: "d-inline-flex gap-3 ps-3 align-items-center justify-content-center" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-times",
  "aria-hidden": "true",
  style: {"font-size":"1.8rem","padding":"0","margin":"0","margin-top":".18rem"}
}, null, -1))
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = {
  class: "m-0 p-0",
  style: {"cursor":"pointer"}
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.5",
    d: "M11.5625 14.9993H8.4375C7.91797 14.9993 7.5 14.5812 7.5 14.0616V7.49817H4.07422C3.37891 7.49817 3.03125 6.6582 3.52344 6.16594L9.46484 0.219759C9.75781 -0.0732529 10.2383 -0.0732529 10.5312 0.219759L16.4766 6.16594C16.9688 6.6582 16.6211 7.49817 15.9258 7.49817H12.5V14.0616C12.5 14.5812 12.082 14.9993 11.5625 14.9993ZM20 14.6867V19.0624C20 19.582 19.582 20 19.0625 20H0.9375C0.417969 20 0 19.582 0 19.0624V14.6867C0 14.1671 0.417969 13.7491 0.9375 13.7491H6.25V14.0616C6.25 15.2688 7.23047 16.2495 8.4375 16.2495H11.5625C12.7695 16.2495 13.75 15.2688 13.75 14.0616V13.7491H19.0625C19.582 13.7491 20 14.1671 20 14.6867ZM15.1562 18.1247C15.1562 17.695 14.8047 17.3434 14.375 17.3434C13.9453 17.3434 13.5938 17.695 13.5938 18.1247C13.5938 18.5545 13.9453 18.9061 14.375 18.9061C14.8047 18.9061 15.1562 18.5545 15.1562 18.1247ZM17.6562 18.1247C17.6562 17.695 17.3047 17.3434 16.875 17.3434C16.4453 17.3434 16.0938 17.695 16.0938 18.1247C16.0938 18.5545 16.4453 18.9061 16.875 18.9061C17.3047 18.9061 17.6562 18.5545 17.6562 18.1247Z",
    fill: "#ED2B46"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.5627 14.9993H8.43769C7.91816 14.9993 7.50019 14.5812 7.50019 14.0616V7.49817H4.07441C3.37909 7.49817 3.03144 6.6582 3.52363 6.16594L9.46503 0.219759C9.758 -0.0732529 10.2385 -0.0732529 10.5314 0.219759L16.4767 6.16594C16.9689 6.6582 16.6213 7.49817 15.926 7.49817H12.5002V14.0616C12.5002 14.5812 12.0822 14.9993 11.5627 14.9993Z",
    fill: "#ED2B46"
  })
], -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-eye",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0","font-size":"1.2rem"}
}, null, -1))
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = {
  class: "col-12 p-2 me-0",
  id: "container_inputSearch",
  style: {"position":"relative"}
}
const _hoisted_81 = { key: 4 }
const _hoisted_82 = {
  key: 0,
  class: "d-flex gap-2 p-2 m-2 flex-wrap align-items-center",
  style: {"border":"1.5px solid var(--cor_background_2)","border-radius":".3rem"}
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_84 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center m-4"
}
const _hoisted_85 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_86 = ["disabled"]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-left",
  id: "container_ISearch",
  "aria-hidden": "true",
  style: {"right":"1.5rem","top":"0.8rem","margin":"0","padding":"0","font-size":"1.5rem","color":"white"}
}, null, -1))
const _hoisted_88 = ["disabled"]
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-right",
  id: "container_ISearch",
  "aria-hidden": "true",
  style: {"right":"1.5rem","top":"0.8rem","margin":"0","padding":"0","font-size":"1.5rem","color":"white"}
}, null, -1))
const _hoisted_90 = ["disabled"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-right",
  id: "container_ISearch",
  "aria-hidden": "true",
  style: {"right":"1.5rem","top":"0.8rem","margin":"0","padding":"0","font-size":"1.5rem","color":"white"}
}, null, -1))
const _hoisted_92 = ["disabled"]
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-right",
  id: "container_ISearch",
  "aria-hidden": "true",
  style: {"right":"1.5rem","top":"0.8rem","margin":"0","padding":"0","font-size":"1.5rem","color":"white"}
}, null, -1))
const _hoisted_94 = ["disabled"]
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-paper-plane",
  id: "container_ISearch",
  "aria-hidden": "true",
  style: {"right":"1.5rem","top":"0.8rem","margin":"0","padding":"0","font-size":"1.5rem","color":"white"}
}, null, -1))
const _hoisted_96 = {
  key: 1,
  class: "d-flex justify-content-between align-items-center m-4"
}
const _hoisted_97 = ["disabled"]
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-right",
  id: "container_ISearch",
  "aria-hidden": "true",
  style: {"right":"1.5rem","top":"0.8rem","margin":"0","padding":"0","font-size":"1.5rem","color":"white"}
}, null, -1))
const _hoisted_99 = {
  class: "modal fade",
  id: "staticBackdrop",
  tabindex: "-1",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_100 = { class: "modal-dialog" }
const _hoisted_101 = { class: "modal-content" }
const _hoisted_102 = { class: "modal-body" }
const _hoisted_103 = {
  key: 0,
  class: "w-100"
}
const _hoisted_104 = ["src"]
const _hoisted_105 = {
  key: 0,
  controls: "",
  class: "w-100",
  ref: "mediaVideoURLRef"
}
const _hoisted_106 = ["src", "type"]
const _hoisted_107 = {
  key: 1,
  controls: "",
  class: "w-100",
  ref: "mediaVideoURLRef"
}
const _hoisted_108 = ["src", "type"]
const _hoisted_109 = ["src"]
const _hoisted_110 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_ElConfigProvider = _resolveComponent("ElConfigProvider")!
  const _component_CampTiptapEditor = _resolveComponent("CampTiptapEditor")!
  const _component_ModalCropImage = _resolveComponent("ModalCropImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.resetValues(); _ctx.resetEditorValues(); _ctx.handleResetMedia()}),
              type: "button",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              ref: "refModalDel",
              style: {"background-color":"transparent","border":"none"}
            }, _hoisted_8, 512)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("section", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.switNumberStep === 1 ? 'switch_notification_select' : 'switch_notification')
              }, _hoisted_13, 2),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.switNumberStep === 2 ? 'switch_notification_select' : 'switch_notification')
              }, _hoisted_15, 2),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.switNumberStep === 3 ? 'switch_notification_select' : 'switch_notification')
              }, _hoisted_17, 2),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.switNumberStep === 4 ? 'switch_notification_select' : 'switch_notification')
              }, _hoisted_19, 2)
            ]),
            _createElementVNode("div", _hoisted_20, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_el_skeleton, {
                    key: 0,
                    rows: 5,
                    animated: ""
                  }))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.modalCompanyShow && !_ctx.loading && _ctx.switNumberStep == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  (_ctx.userLevel <= 100)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "d-flex align-items-center justify-content-between w-100",
                        style: {"cursor":"pointer","border-radius":"8px","padding":"1rem"},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectAll()))
                      }, _hoisted_25))
                    : _createCommentVNode("", true),
                  (_ctx.userLevel <= 200)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "d-flex align-items-center justify-content-between w-100",
                        style: {"cursor":"pointer","padding":"1rem"},
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectCompany && _ctx.selectCompany(...args)))
                      }, _hoisted_29))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "d-flex align-items-center justify-content-between w-100",
                    style: {"cursor":"pointer","padding":"1rem"},
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectStore()))
                  }, _hoisted_33),
                  _createElementVNode("div", {
                    class: "d-flex align-items-center justify-content-between w-100",
                    style: {"cursor":"pointer","padding":"1rem"},
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectCompetitor()))
                  }, _hoisted_37)
                ]))
              : _createCommentVNode("", true),
            (_ctx.modalCompanyShow && !_ctx.loading  && _ctx.switNumberStep == 1)
              ? (_openBlock(), _createElementBlock("section", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.filterDom,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterDom) = $event)),
                      placeholder: "Pesquisar...",
                      class: "w-100 h-100 p-0",
                      type: "text"
                    }, null, 8, ["modelValue"]),
                    _hoisted_40
                  ]),
                  _createElementVNode("label", _hoisted_41, [
                    _createElementVNode("span", _hoisted_42, [
                      _createTextVNode("Selecionar todos "),
                      _createVNode(_component_el_checkbox, {
                        size: "large",
                        modelValue: _ctx.isAlltrue,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isAlltrue) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("ul", _hoisted_43, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies?.filter(elem => {
                  if(elem.company.fantasy_name) return elem.company.fantasy_name?.toLowerCase().includes(_ctx.filterDom.toLowerCase())
                  else 
                  return elem.company.name?.toLowerCase().includes(_ctx.filterDom.toLowerCase())
                  }), (company) => {
                      return (_openBlock(), _createElementBlock("label", {
                        class: "p-2 d-flex w-100 justify-content-between rounded",
                        style: {"cursor":"pointer"},
                        key: company.id
                      }, [
                        _createElementVNode("span", null, _toDisplayString(company.company.fantasy_name? company.company.fantasy_name : company.company.name), 1),
                        _createVNode(_component_el_checkbox, {
                          size: "large",
                          modelValue: company.checked,
                          "onUpdate:modelValue": ($event: any) => ((company.checked) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]))
                    }), 128))
                  ]),
                  (_ctx.entityFilter.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityFilter, (company) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "px-3 py-1",
                            style: {"background-color":"var(--cor_background_2)","border-radius":".35rem"},
                            key: company.company.id
                          }, [
                            _createTextVNode(_toDisplayString(company.company.fantasy_name? company.company.fantasy_name : company.company.name) + " ", 1),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.setEntity(company)),
                              type: "button",
                              class: "p-0 m-0 ms-3 border-0",
                              style: {"background-color":"transparent"}
                            }, _hoisted_47, 8, _hoisted_45)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.switNumberStep == 2)
              ? (_openBlock(), _createElementBlock("section", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.senderId ? 'col-6' : 'col-12')
                    }, [
                      _hoisted_50,
                      _createVNode(_component_el_select, {
                        id: "select-sender-68c1a29e-c6e2-4feb-b6ec-9fb9debb6432",
                        class: "w-100",
                        modelValue: _ctx.senderId,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.senderId) = $event)),
                        placeholder: "Selecione a prioridade",
                        disabled: !_ctx.senderList?.length
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.senderList, (sender) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: sender.key,
                              label: sender.label,
                              value: sender.key
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ], 2),
                    (_ctx.senderId === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _hoisted_52,
                          _createVNode(_component_el_select, {
                            id: "select-company-68c1a29e-c6e2-4feb-b6ec-9fb9debb6432",
                            class: "w-100",
                            modelValue: _ctx.senderCompanyId,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.senderCompanyId) = $event)),
                            placeholder: "Selecione a prioridade",
                            disabled: !_ctx.senderCompanyList?.length
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.senderCompanyList, (sender) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: sender.key,
                                  label: sender.label,
                                  value: sender.key
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.senderId === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _hoisted_54,
                          _createVNode(_component_el_select, {
                            id: "select-store-68c1a29e-c6e2-4feb-b6ec-9fb9debb6432",
                            class: "w-100",
                            modelValue: _ctx.senderStoreId,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.senderStoreId) = $event)),
                            placeholder: "Selecione a prioridade",
                            disabled: !_ctx.senderStoreList?.length
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.senderStoreList, (sender) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: sender.key,
                                  label: sender.label,
                                  value: sender.key
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createVNode(_component_ElConfigProvider, { locale: _ctx.ptBr }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("div", _hoisted_57, [
                            _hoisted_58,
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.config.date,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.config.date) = $event)),
                              class: "w-100",
                              type: "date",
                              placeholder: "Selecione a data",
                              format: "DD/MM/YYYY",
                              locale: "pt-br",
                              disabledDate: _ctx.disabledDateInNotification
                            }, null, 8, ["modelValue", "disabledDate"])
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            _hoisted_60,
                            _createVNode(_component_el_time_picker, {
                              modelValue: _ctx.config.time,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.config.time) = $event)),
                              class: "w-100",
                              placeholder: "Selecione a hora",
                              format: "HH:mm:ss",
                              "value-format": "HH:mm:ss",
                              disabledDate: _ctx.disabledDateInNotification
                            }, null, 8, ["modelValue", "disabledDate"])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["locale"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.switNumberStep == 3 && !_ctx.loading)
              ? (_openBlock(), _createElementBlock("section", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("span", null, [
                      _createTextVNode(" De: "),
                      (Array.isArray(_ctx.senderList) && _ctx.senderList.length && +_ctx.senderList[_ctx.senderId].key > 0)
                        ? (_openBlock(), _createElementBlock("strong", _hoisted_63, _toDisplayString(_ctx.senderList[_ctx.senderId].label), 1))
                        : _createCommentVNode("", true),
                      (Array.isArray(_ctx.senderList) && _ctx.senderList.length && +_ctx.senderList[_ctx.senderId].key > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(` ${_ctx.senderDesc}`), 1))
                        : (_openBlock(), _createElementBlock("strong", _hoisted_65, _toDisplayString(` ${_ctx.senderDesc}`), 1))
                    ])
                  ]),
                  (_ctx.entityFilter.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        _createElementVNode("span", null, [
                          _createTextVNode(" Enviando para: " + _toDisplayString(" ") + " "),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.sendTo === "Vendedor" ? 
                        _ctx.entityFilter.length > 1 ? _ctx.sendTo + 'es' : _ctx.sendTo :
                        _ctx.entityFilter.length > 1 ? _ctx.sendTo + 's' : _ctx.sendTo), 1),
                          _createTextVNode(" " + _toDisplayString(" "))
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityFilter, (company) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "px-3 py-1",
                            style: {"background-color":"var(--cor_background_2)","border-radius":".35rem"},
                            key: company.company.id
                          }, [
                            _createTextVNode(_toDisplayString(company.company.fantasy_name? company.company.fantasy_name : company.company.name) + " ", 1),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.setEntity(company)),
                              type: "button",
                              class: "p-0 m-0 ms-3 border-0",
                              style: {"background-color":"transparent"}
                            }, _hoisted_69, 8, _hoisted_67)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                        _createElementVNode("span", null, [
                          _createTextVNode("Para: "),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.sendTo ? _ctx.sendTo : 'Todos'), 1)
                        ])
                      ])),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(`color: ${_ctx.send.media ? 'var(--cor_texto_1)' : 'var(--cor_texto_2)'}`)
                      }, _toDisplayString(_ctx.send.mediaName.includes('.') ? _ctx.truncateFileName(_ctx.send.mediaName, 22) : _ctx.send.mediaName), 5),
                      _createElementVNode("span", _hoisted_73, [
                        _createElementVNode("button", {
                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleResetMedia && _ctx.handleResetMedia(...args))),
                          type: "button",
                          class: "p-0 m-0 border-0",
                          style: {"background-color":"transparent"}
                        }, _hoisted_75),
                        _createElementVNode("label", _hoisted_76, [
                          _hoisted_77,
                          _createElementVNode("input", {
                            type: "file",
                            onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
                            placeholder: "Escolha uma media",
                            class: "d-none"
                          }, null, 32)
                        ])
                      ])
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm background_btn_1_opct",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openModal('staticBackdrop')))
                    }, _hoisted_79)
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    (_ctx.editor)
                      ? (_openBlock(), _createBlock(_component_CampTiptapEditor, {
                          key: 0,
                          editor: _ctx.editor,
                          "hidden-starter-kit-items": []
                        }, null, 8, ["editor"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.switNumberStep == 4 && !_ctx.loading)
              ? (_openBlock(), _createElementBlock("section", _hoisted_81, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.idJob,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.idJob) = $event)),
                    class: "col-12 p-2 me-0",
                    placeholder: "Selecione o template"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobName, (job, key) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: key,
                          value: key,
                          label: job.label
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.idJob !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.jobName[_ctx.idJob]?.title) + " ", 1),
                          _hoisted_83,
                          _createTextVNode(" " + _toDisplayString(_ctx.jobName[_ctx.idJob]?.message), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (!_ctx.idPost)
          ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("button", {
                  disabled: !_ctx.modalCompanyShow && _ctx.switNumberStep <= 1,
                  class: "btn background_btn_1_opct",
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.backSwitch && _ctx.backSwitch(...args)))
                }, [
                  _hoisted_87,
                  _createTextVNode(" Voltar ")
                ], 8, _hoisted_86)
              ]),
              (_ctx.switNumberStep == 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    disabled: !_ctx.entityFilter.length,
                    class: "btn background_btn_1 d-flex align-items-center",
                    style: {"gap":"1rem","color":"white"},
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.switNumberStep < 3 ? _ctx.switNumberStep = _ctx.switNumberStep + 1: _ctx.switNumberStep))
                  }, [
                    _hoisted_89,
                    _createTextVNode(" Avançar ")
                  ], 8, _hoisted_88))
                : _createCommentVNode("", true),
              (_ctx.switNumberStep == 2)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn background_btn_1 d-flex align-items-center",
                    style: {"gap":"1rem","color":"white"},
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.switNumberStep < 3 ? _ctx.switNumberStep = _ctx.switNumberStep + 1: _ctx.switNumberStep)),
                    disabled: _ctx.senderForwardBtnDisabled
                  }, [
                    _hoisted_91,
                    _createTextVNode(" Avançar ")
                  ], 8, _hoisted_90))
                : _createCommentVNode("", true),
              (_ctx.switNumberStep == 3)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn background_btn_1 d-flex align-items-center",
                    style: {"gap":"1rem","color":"white"},
                    onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.handlerSenderList(); _ctx.switNumberStep < 4 ? _ctx.switNumberStep = _ctx.switNumberStep + 1: _ctx.switNumberStep}),
                    disabled: (!_ctx.send.message.length || _ctx.loading)
                  }, [
                    _hoisted_93,
                    _createTextVNode(" Avançar ")
                  ], 8, _hoisted_92))
                : _createCommentVNode("", true),
              (_ctx.switNumberStep == 4)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.postPost && _ctx.postPost(...args))),
                    disabled: (_ctx.idJob == null || _ctx.loading),
                    class: "btn background_btn_1 d-flex align-items-center",
                    style: {"gap":"1rem","color":"white"}
                  }, [
                    _hoisted_95,
                    _createTextVNode(" Publicar ")
                  ], 8, _hoisted_94))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.idPost)
          ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
              (_ctx.switNumberStep == 3)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn background_btn_1 d-flex align-items-center",
                    style: {"gap":"1rem","color":"white"},
                    onClick: _cache[21] || (_cache[21] = ($event: any) => {_ctx.putPost();}),
                    disabled: (!_ctx.send.message.length || _ctx.loading)
                  }, [
                    _hoisted_98,
                    _createTextVNode(" Atualizar ")
                  ], 8, _hoisted_97))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_ModalCropImage, {
          maxFileSizeMD: 2,
          canvasWidth: 1920,
          canvasHeight: 1080,
          thumbnailWidth: 200,
          thumbnailHeight: 200,
          sizeCanvasFixed: false,
          productImgFile: _ctx.send.imgToCrop,
          onGetImgResults: _ctx.setImageCroped
        }, null, 8, ["productImgFile", "onGetImgResults"]),
        _createElementVNode("div", _hoisted_99, [
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("div", _hoisted_102, [
                (_ctx.send.media)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                      (_ctx.isImageFile)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.send.media,
                            style: {"width":"100%","object-fit":"contain","border":"1px solid #e1e1e1"}
                          }, null, 8, _hoisted_104))
                        : _createCommentVNode("", true),
                      (_ctx.isVideoFile)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.totalVideoUpload % 2 == 0)
                              ? (_openBlock(), _createElementBlock("video", _hoisted_105, [
                                  _createElementVNode("source", {
                                    src: _ctx.send.media,
                                    type: _ctx.contentType
                                  }, null, 8, _hoisted_106),
                                  _createTextVNode(" Seu navegador não suporta o elemento de vídeo. ")
                                ], 512))
                              : (_openBlock(), _createElementBlock("video", _hoisted_107, [
                                  _createElementVNode("source", {
                                    src: _ctx.send.media,
                                    type: _ctx.contentType
                                  }, null, 8, _hoisted_108),
                                  _createTextVNode(" Seu navegador não suporta o elemento de vídeo. ")
                                ], 512))
                          ], 64))
                        : _createCommentVNode("", true),
                      (!_ctx.isImageFile && _ctx.send.media)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 2,
                            src: _ctx.send.media,
                            style: {"width":"100%","object-fit":"contain","border":"1px solid #e1e1e1"}
                          }, null, 8, _hoisted_109))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "rounded",
                      style: {"width":"100%","object-fit":"contain","border":"1px solid #e1e1e1"},
                      src: _ctx.imgDefalt,
                      alt: ""
                    }, null, 8, _hoisted_110))
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn background_btn_1_opct",
                "data-bs-dismiss": "staticBackdrop",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.auxModal.hide()))
              }, "Fechar")
            ])
          ])
        ])
      ])
    ])
  ]))
}